import './ContactUsDetails.css';

const ContactUsDetails =(props) =>{
    const desktopWidth = window.innerWidth > 600 ? true: false;
    const frameSize = desktopWidth ? 548: 343 ;
    const contactUsDetailsItems= props.items.map((item,idx)=>{
        if(item.MashanIsActive){
            return (<div className="col-12 col-md-12 row" key={idx}>
                <h2 className="newslettertitle-title-text" role='heading'></h2>
                    <div className="col-12 col-md-12 row" dangerouslySetInnerHTML={{__html:item.RichTextContainer}}>
                       
                    </div>
                    <div className="col-12 col-md-10">
                        <iframe src={item.MashanContainerLink.NavigateUrl} width={frameSize}  height={frameSize}
                            style={{border:0}} allowFullScreen=""  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
            </div>)
        }

    });

    return (<div className="container-contactusdetails-wrapper  col-12 col-md-12 row">
                {contactUsDetailsItems}
            </div>);
}

export default ContactUsDetails;